module.exports = __webpack_public_path__ + "img/logo.3e9e2e77.png";